import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const PERSONAL = [
  "拖延",
  "三分鐘熱度",
  "缺乏行動力",
  "方向不清楚",
  "自我懷疑",
  "目標總是做不到",
];

const BUSINESS = [
  "主管培訓",
  "人才發展",
  "團隊執行力",
  "目標管理",
  "工作與時間管理",
  "學習轉化",
];

export default function PathwaySection() {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="選擇你的路徑"
            title="你現在，想改變的是自己，還是你的團隊？"
            align="center"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal delay={60}>
            <div className="h-full rounded-card bg-cream border border-line p-8 md:p-9 flex flex-col">
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary/10">
                <i className="ri-user-heart-line text-2xl text-primary" aria-hidden="true"></i>
              </div>
              <h3 className="mt-5 text-2xl font-bold text-ink">個人成長</h3>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {PERSONAL.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm text-ink-soft">
                    <i className="ri-check-line text-gold" aria-hidden="true"></i>
                    {p}
                  </li>
                ))}
              </ul>
              <div className="mt-8 pt-6 border-t border-line mt-auto">
                <Button to="/personal-growth" variant="outline" icon="ri-arrow-right-line">
                  探索個人成長
                </Button>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="h-full rounded-card bg-primary text-white p-8 md:p-9 flex flex-col">
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-gold/20">
                <i className="ri-team-line text-2xl text-gold" aria-hidden="true"></i>
              </div>
              <h3 className="mt-5 text-2xl font-bold">企業與團隊</h3>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {BUSINESS.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm text-white/85">
                    <i className="ri-check-line text-gold" aria-hidden="true"></i>
                    {p}
                  </li>
                ))}
              </ul>
              <div className="mt-8 pt-6 border-t border-white/15 mt-auto">
                <Button to="/corporate-training" variant="outline-light" icon="ri-arrow-right-line">
                  了解企業與團隊培訓
                </Button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}